module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/05eaa5ac64662148b01e96f636a1d7b4.png";